// 获取物料上传列表
import { useContext, useEffect, useState } from "react"
import { AppContext } from "Views/Home/context"
import { useAssign } from "Hooks/basic"
import { Material } from "Types/material"
import { InitialModal } from "Methods/modal"
import request from "Methods/request"
let updateLock = false

interface MaterialsSearchQuery {
    page: number,
    totalCount: number,
    keyword?: string | null,
    status?: string | null,
    placeId?: number | null,
    startTime?: Date | null,
    endTime?: Date | null,
    isDraft?: boolean
}

const generateParams = (query: MaterialsSearchQuery, channelName: string) => {
    const params: any = {}
    Object.entries(query).forEach(([key, value]) => {
        if (key === "placeId" && value) {
            if (channelName === "wechat") {
                params.seq_id = value
            } else {
                if (value === -1) {
                    params.is_draft = true
                } else {
                    params.ad_place_id = value
                    params.is_draft = false
                }
            }
        } else if (key === "startTime" && value) {
            params.start_time = value
        } else if (key === "endTime" && value) {
            params.end_time = value
        } else if (value) {
            params[key] = value
        }
    })
    return params
}

export function useFetchMaterials(chanelName = "") {
    const materialType = "upload"
    const limit = 20
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<Material[]>([])
    const { object: query, handleChange: handleChangeQuery } = useAssign<MaterialsSearchQuery>({
        page: 1,
        totalCount: 1,
        keyword: null,
        status: null,
        placeId: null,
        startTime: null,
        endTime: null,
        isDraft: false,
    })
    const { handleChangeModal } = useContext(AppContext)
    const fetch = async () => {
        setLoading(true)
        try {
            const params: any = {
                limit,
                // material_type: materialType,
                channel_name: chanelName,
                page: query.page,
            }
            if (!chanelName) {
                delete params.channel_name
            } else {
                // params.material_type = "censor"
                // generateParams
                const newParams = generateParams(query, chanelName)
                delete newParams.totalCount
                Object.assign(params, newParams)
            }
            const {
                data,
                headers: {
                    "x-total-count": totalCount,
                },
            } = await request.get("/apis/materials", {
                params,
            })
            console.log(data)
            setData(data)
            handleChangeQuery({ totalCount })
        } catch (e) {
        }
        setLoading(false)
    }
    const update = async (newItem: Material) => {
        setLoading(true)
        try {
            await request.put(`/apis/material/${newItem.id}/update`, newItem)
            handleChangeModal({
                show: true,
                type: "success",
                title: "修改成功！",
                timeout: 800,
                onConfirm: () => {
                    handleChangeModal(InitialModal)
                },
            })
        } catch (err) {
            if (!navigator.onLine) {
                handleChangeModal({
                    show: true,
                    type: "warning",
                    customButtons: [],
                    title: "oops! 断网啦！",
                    timeout: 3000,
                    onConfirm: () => {
                        handleChangeModal(InitialModal)
                    },
                })
                return
            }
            const { response: { data = {} } = {}, message } = err
            handleChangeModal({
                show: true,
                type: "warning",
                customButtons: [],
                title: data.message || message,
                timeout: 3000,
                onConfirm: () => {
                    handleChangeModal(InitialModal)
                },
            })
        }
        setLoading(false)
    }
    useEffect(() => {
        fetch()
        // eslint-disable-next-line
    }, [query.page, query.keyword, query.placeId, query.status, query.startTime, query.endTime, query.isDraft])
    const handleChangeItem = async (index: number, newItem: Material) => {
        if (updateLock) {
            return
        }
        updateLock = true
        await update(newItem)
        await fetch()
        updateLock = false
    }
    return {
        data, query, loading,
        handleChangeItem, handleChangeQuery,
    }
}
